import { button } from 'ui/styles/Commons/button';

export const inventoryProducts = {
  container: {},
  updateInventory: {
    ...button.yellow,
  },
};
